import axios from 'axios'
import { getResponseData } from 'src/queries/network.utils'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

import { VirtualCardTypesResponse } from './virtualCardTypes.types'

export const getOrganizationVirtualCardTypes = async (
  orgId: string,
): Promise<VirtualCardTypesResponse> =>
  getResponseData(
    axios.get<VirtualCardTypesResponse>(
      `/organizations/${orgId}/virtualcardtypes`,
      getRequestConfig(RequestConfig.Default),
    ),
  )
